import { buildRestrictionDescription } from '@components/Checkout/steps/InstallationStep/utils/installationStepUtils';
import { ActiveForm } from '@components/Checkout/steps/InstallationStep/ActiveForm';
import type { InstallationStepProps } from '@components/Checkout/steps/InstallationStep/InstallationStep.types';
import { ViewOnly } from '@components/Checkout/steps/InstallationStep/ViewOnly';

export const InstallationStep = ({
  isActive,
  isCompleted,
  sessionId,
  technicianOptions,
  pickupAddress,
  workTime,
  isSlotsLoading,
  savedValues,
  isSaving,
  onSave,
  onDateRangeChange,
  accessRestrictions,
  showInitialInfoDialog,
  onInfoDialogShown,
}: InstallationStepProps) => {
  const restrictionDescription = buildRestrictionDescription(accessRestrictions);

  if (isCompleted && !isActive) {
    return (
      <ViewOnly
        savedValues={savedValues}
        pickupAddress={pickupAddress}
        restrictionDescription={restrictionDescription}
      />
    );
  }

  if (!isActive) return null;

  return (
    <ActiveForm
      sessionId={sessionId}
      technicianOptions={technicianOptions}
      pickupAddress={pickupAddress}
      workTime={workTime}
      isSlotsLoading={isSlotsLoading}
      savedValues={savedValues}
      isSaving={isSaving}
      restrictionDescription={restrictionDescription}
      showInitialInfoDialog={showInitialInfoDialog}
      onInfoDialogShown={onInfoDialogShown}
      onSave={onSave}
      onDateRangeChange={onDateRangeChange}
    />
  );
};
